module.exports = __webpack_public_path__ + "res/img_timer.0b97ec0fff74248fc83e2f5dce31ec7d.png";